import QRCode from 'qrcode.react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import Model3D from '@/components/Model3D';

export default function J() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar60w');
    const [activeTab, setActiveTab] = useState(0);
    const [activeSubtab, setActiveSubtab] = useState(0);
    const [qrcodeUrl, setQRCodeUrl] = useState('');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setQRCodeUrl(`${window?.origin}/${locale}/ar?glb=/models/solar-60w/${activeSubtab + 1}.glb&redirect=/${locale}/60w-solar-panel`);
        }
    }, [activeSubtab, locale]);

    return (
        <div className={`solar-60w-J ${css['solar-60w-J']}`}>
            <div className="sec10">
                <div className="sec5-title">{t('sec10_title')}</div>
                <div className="switch-tabs">
                    <div className="tabs-box">
                        <div className={`tab-menu ${activeTab === 0 ? 'active' : ''}`} onClick={() => activeTab !== 0 && setActiveTab(0)}>
                            {t('sec10_tab1')}
                        </div>
                        <div className={`tab-menu ${activeTab === 1 ? 'active' : ''}`} onClick={() => activeTab !== 1 && setActiveTab(1)}>
                            <div className={`menu-text`}>{t('sec10_tab2')}</div>
                        </div>
                    </div>
                    <div className="tabs-content">
                        <div className={`tab-content-3D tab-content-box ${activeTab === 0 ? 'active' : ''}`}>
                            <div className="tab-content-text-box">
                                <p className="tab-content-title">{t('sec10_tab1_title')}</p>
                                <p className="tab-content-desc">{t('sec10_tab1_desc')}</p>
                                <div className="switch-sub-tab-box">
                                    <div
                                        className={`sub-tab-menu ${activeSubtab === 0 ? 'active' : ''}`}
                                        onClick={() => activeSubtab !== 0 && setActiveSubtab(0)}
                                    >
                                        {t('sec10_tab1_sub_tab1')}
                                    </div>
                                    <div
                                        className={`sub-tab-menu ${activeSubtab === 1 ? 'active' : ''}`}
                                        onClick={() => activeSubtab !== 1 && setActiveSubtab(1)}
                                    >
                                        {t('sec10_tab1_sub_tab2')}
                                    </div>
                                </div>
                            </div>
                            <div className="tab-content-3d-model">
                                {activeSubtab === 0 && <Model3D props={{ style: { width: '640px', height: '540px' }, src: '/models/solar-60w/1.glb' }} />}
                                {activeSubtab === 1 && <Model3D props={{ style: { width: '640px', height: '540px' }, src: '/models/solar-60w/2.glb' }} />}
                            </div>
                        </div>
                        <div className={`tab-content-AR tab-content-box ${activeTab === 1 ? 'active' : ''}`}>
                            <div className="back-img">
                                {activeSubtab === 0 ? (
                                    <NextImage
                                        src={require('@publicLocal/solar-60w/pc/10_1.png')}
                                        alt={t('sec10_tab2_title')}
                                        aria-label={t('sec10_tab2_title')}
                                    />
                                ) : (
                                    <NextImage
                                        src={require('@publicLocal/solar-60w/pc/10_2.png')}
                                        alt={t('sec10_tab2_title')}
                                        aria-label={t('sec10_tab2_title')}
                                    />
                                )}
                            </div>
                            <div className="tab-content-text-box">
                                <div className="qr-code">
                                    <QRCode value={qrcodeUrl} renderAs="canvas" />
                                </div>
                                <p className="tab-content-title">{t('sec10_tab2_title')}</p>
                                <p className="tab-content-desc">{t('sec10_tab2_desc')}</p>
                                <div className="switch-sub-tab-box">
                                    <div
                                        className={`sub-tab-menu ${activeSubtab === 0 ? 'active' : ''}`}
                                        onClick={() => activeSubtab !== 0 && setActiveSubtab(0)}
                                    >
                                        {t('sec10_tab1_sub_tab1')}
                                    </div>
                                    <div
                                        className={`sub-tab-menu ${activeSubtab === 1 ? 'active' : ''}`}
                                        onClick={() => activeSubtab !== 1 && setActiveSubtab(1)}
                                    >
                                        {t('sec10_tab1_sub_tab2')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
